import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";
import { recipes } from "./recipes";
import { textStyles } from "./textStyles";
import * as colors from "./tokens/colors";
import * as fontSizes from "./tokens/fontSizes";
import * as shadows from "./tokens/shadows";

const defaultConfigOverride = {
  ...defaultConfig,
  globalCss: {
    ...defaultConfig.globalCss,
    "*::selection": {}, // selection カラーはブラウザ標準のものを使う
  },
};

const config = defineConfig({
  globalCss: {
    html: {
      colorPalette: "primary",
      lineHeight: "1.2",
    },
    "*::selection": {},
  },
  theme: {
    tokens: {
      colors: colors.tokens,
      fontSizes: fontSizes.tokens,
      shadows: shadows.tokens,
    },
    semanticTokens: {
      colors: colors.semanticTokens,
    },
    recipes,
    textStyles,
  },
});

export const system = createSystem(defaultConfigOverride, config);
